/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ReorderClassroomDisFolderItemViewModel } from "../types/ReorderClassroomDisFolderItemViewModel.ts";

export const reorderClassroomDisFolderItemViewModelSchema = z.object({
  folderId: z.optional(z.number().int()),
  parentFolderId: z.number().int().nullish(),
}) as unknown as ToZod<ReorderClassroomDisFolderItemViewModel>;
